import { useI18n } from '../i18n';

// Rendered unconditionally on the check-in screen, before and after
// submission alike. Never put this behind a condition on the mood value —
// the whole point is that it shows no matter what a student picks.
// `message`: the school's own text in the student's language (set by the
// school during setup); without one, the generic message is shown.
// `safetyValve`: 0026's closing question makes the old generic message's
// "it can't send anyone to check on you" claim false on sessions where
// it's on, so that session shows the corrected wording instead — only for
// the GENERIC text; a school's own override is never second-guessed.
export function SafetyNet({ message, safetyValve }: { message?: string | null; safetyValve?: boolean }) {
  const { t } = useI18n();
  return (
    <aside className="sx-safety" aria-label={t['safety.label']}>
      <span className="icon" aria-hidden="true">💛</span>
      <p>{message?.trim() || (safetyValve ? t['r6.ci.safetyNetMessage'] : t['safety.message'])}</p>
    </aside>
  );
}
